// src/components/KeyClients.tsx
import React from "react";
import client1 from "../../images/Akshar.webp";
import client2 from "../../images/Gasorex-logo.webp";
import client3 from "../../images/Satvij.webp";
import client4 from "../../images/newimage.webp";
import client5 from "../../images/anjalielectronics.webp"

const KeyClients: React.FC = () => {
  const clients: string[] = [client1, client2, client3, client4, client5];

  return (
    <section className="py-11 bg-white overflow-hidden mt-10 mb-10">
      {/* Heading */}
      <div className="text-center mb-8">
        <h2 className="text-[24px] md:text-[28px] font-semibold">
          Our Key Clients
        </h2>
        <p className="text-black text-[18px] md:text-[18px]">
          Trusted by the Best in the Industry
        </p>
      </div>

      {/* Continuous Row */}
      <div className="relative w-full overflow-hidden">
        <div className="flex animate-scroll-right">
          {/* Create multiple sets for continuous flow */}
          {Array.from({ length: 20 }).map((_, setIndex) =>
            clients.map((src, idx) => (
              <div
                key={`set-${setIndex}-${idx}`}
                className="flex-shrink-0 w-28 h-20 sm:w-36 sm:h-24 md:w-48 md:h-28 flex items-center justify-center mx-2 sm:mx-4 bg-gray-50 rounded-lg shadow-md"
              >
                <img
                  src={src}
                  alt={`Client ${(idx % 5) + 1}`}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default KeyClients;
